$(document).ready(function () {

  $('body').on('click', '#btn-form-contact', function () {
    var formData = $('#admision-contacto').serializeArray();
    formData.push({
      name: 'action',
      value: 'form-ajax-nonce'
    });
    formData.push({
      name: 'security',
      value: $('#form-ajax-nonce').val()
    });

    $('#btn-form-contact').addClass('button--loading');

    $('[data-parent]').addClass('sending');

    $.post(data.base_url + 'contact', $.param(formData), function (json) {

      json = JSON.parse(json);

      if (json.code == 422) {
        for (input in json.data) {
          $('[name=' + input + ']').addClass('invalid-input').parents('.form-control').attr('data-error-message', json.data[input]).addClass('form-control--invalid');
          $('[name=' + input + ']').siblings('.form-control__text').hide();
          removeClass($('[name=' + input + ']'));
        }
      }

      if (json.code == 200) {
        $('#admision-contacto')[0].reset();

        $('[data-parent]').html(
          '<div class="message message--ghost-success message--response" data-module="message"><div class="message__container"><figure class="message__figure"></figure><h4 class="message__title">¡Gracias por su mensaje!</h4><div class="message__body"> <p>' + json.msg + '</p></div></div></div>'
        );
      }

      if (json.code == 500) {
        $('#msj_contacto').html('<div class="message message--ghost-danger" data-module="message"> <div class="message__body"> <p>' + json.msg + '</p> </div> <button class="message__close-button" data-role="close"></button> </div>');
      }

      setTimeout(function () {
        $('#msj_contacto .message').remove();
      }, 4000);

      $('#btn-form-contact').removeClass('button--loading');

      $('[data-parent]').removeClass('sending');
    });
    return false;
  });


  function removeClass(input) {
    setTimeout(function () {
      input.siblings('.form-control__text').show(); //added
      input.removeClass('invalid-input').parents('.form-control').removeClass('form-control--invalid');
    }, 4000);
  }
});